/**
 * Android's version code of a Teslyn Mobile release (docs/specs/mobile/mobile-distribution.md §3). Kept apart, with
 * no imports, because `apps/mobile/app.config.ts` loads it while Expo reads the app's config (where the domain's JSON
 * imports do not load); `mobile-release.ts` re-exports it.
 */

/**
 * `YYYY·100000 + M·1000 + patch` of a release version (`YYYY.M.patch`, ADR-014), so 2026.10.14 is 202610014. Android
 * installs an update only when its code is larger than the installed one, and this one grows with every release (the
 * digits of the version run together did not: 2026.11.0 gave 2026110, smaller than 2026.10.10's 20261010). Null for
 * text that is not a release version (the same reading as `parseReleaseVersion`) or a patch of 1000 or more.
 */
export function mobileVersionCode(version: string): number | null {
  const m = /^v?(\d{4})\.(\d{1,2})\.(\d+)$/.exec(version.trim());
  if (!m || (m[2]!.length === 2 && m[2]!.startsWith('0'))) return null;
  const [y, mo, p] = [Number(m[1]), Number(m[2]), Number(m[3])];
  if (mo < 1 || mo > 12 || p > 999) return null;
  return y * 100000 + mo * 1000 + p;
}
